import React from 'react';

const AWS_CloudTrail = () => {
  return (
    <div>
      <h1>AWS_CloudTrail</h1>
      <p>This is the AWS_CloudTrail component.</p>
    </div>
  );
};

export default AWS_CloudTrail;
